module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/mediastinal-34519946108611e380fc03f117b0c4f7.png";